import React from 'react';
import PropTypes from 'prop-types';
import LobbyJoinedPlayerRow from './LobbyJoinedPlayerRow';
import { IMAGE_CONSTANTS } from '../constants/ImageConstans';
import { TEXT_LABELS } from '../constants/TextLabelConstants';
import { LIVE_GAME_SECTION_TITLE_STYLE } from '../constants/housieLiveStyles';
import './LiveGameTotalMembersPanel.css';

const DEFAULT_QUESTION_PROGRESS = ['pending', 'pending', 'pending', 'pending', 'pending'];

/**
 * Figma 18423:3739 — RapFire TOTAL MEMBERS glass panel
 * (white 2px outer border, 36px radius, player rows 18423:3743)
 */
const LiveGameTotalMembersPanel = ({ members = [], showQuestionProgress = false }) => {
  const count = members?.length || 0;
  const titlePrefix =
    TEXT_LABELS.RAP_HOUSIE_LIVE_GAME_TOTAL_MEMBERS_PREFIX || 'TOTAL MEMBERS';

  return (
    <div className="live-total-members app-glass-panel" data-node-id="18423:3739">
      <div className="live-total-members__inner" data-node-id="18423:3740">
        <h2 style={{ ...LIVE_GAME_SECTION_TITLE_STYLE, flexShrink: 0 }} data-node-id="18423:3741">
          {`${titlePrefix} (${count})`}
        </h2>
        <div className="live-total-members__list" data-node-id="18423:3742">
          {count > 0 ? (
            members.map((player, index) => {
              const key = player?.id || player?.userId || `user-${index}`;
              const username = player?.username || player?.userName || '';
              const avatar =
                player?.avatar ||
                player?.profilePic ||
                player?.userImage ||
                IMAGE_CONSTANTS.V2_IMAGE_PLACEHOLDER;
              return (
                <LobbyJoinedPlayerRow
                  key={key}
                  username={username}
                  avatar={avatar}
                  gameState={
                    showQuestionProgress
                      ? player?.gameState || DEFAULT_QUESTION_PROGRESS
                      : undefined
                  }
                />
              );
            })
          ) : (
            <span className="live-total-members__empty">
              {TEXT_LABELS.RAP_HOUSIE_ROOM_GAME_CODE_SHARE_NO_PLAYER_SUBTITLE ||
                'Waiting for members to join'}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

LiveGameTotalMembersPanel.propTypes = {
  members: PropTypes.arrayOf(PropTypes.object),
  showQuestionProgress: PropTypes.bool,
};

export default LiveGameTotalMembersPanel;
